import axios from 'axios'
import { baseURL } from './const.js'

const service = axios.create({
  baseURL,
  // withCredentials: false,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 在发送请求之前做点什么
  return config
}, error => {
  console.log(error)
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
  // 对响应数据做点什么
  const res = response.data
  if (res.code !== 200) {
    return Promise.reject(res)
  } else {
    return Promise.resolve(res)
  }
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default service
